import React, { useContext, useState } from "react";
import ControlContext from "../../contexts/control-context";
import ShapeRenderer from "../Workspace/SVGLayer/ShapeRenderer";

import "./../FramesPalette/FramesPalette.css"

const FramesPalette = () => {

    const {
        shapes,
        shapesMap,
        frames,
        framesMap,
        selectedFrameId,
        addFrame,
        reorderFrames,
        deleteSelectedFrame,
        selectFrame,
        changeFrameName,
    } = useContext(ControlContext)

    const [editState, setEditState] = useState(false)

    const shapeRenderer = new ShapeRenderer()

    const [draggingId, setDraggingId] = useState()
    const [oldIdx, setOldIdx] = useState()

    let drag = (e, id) => {
        let ghost = document.getElementById("ghostlayer")

        e.dataTransfer.setDragImage(ghost, 0, 0);

        setDraggingId(id)
        let idx = frames.indexOf(id)
        setOldIdx(idx)
    }

    let dragOver = (e, newId) => {
        e.preventDefault()
        e.dataTransfer.dropEffect = "move"

        let from = frames.indexOf(draggingId)
        let to = frames.indexOf(newId)
        reorderFrames(from, to)
    }

    let drop = () => {
        if (draggingId) {
            reorderFrames(oldIdx, frames.indexOf(draggingId), true)
        }
        setOldIdx(undefined)
        setDraggingId(undefined)
    }

    let getStyle = (id) => {
        let style = {
            outline: "solid 2px lightgray"
        }
        if (selectedFrameId === id) {
            style.outline = "solid lightblue"
        }
        if (draggingId === id) {
            style.display = "block"
            style.boxShadow = "3px 3px 10px 2px gray"
            style.WebkitBoxShadow = "3px 3px 10px 2px gray"
            style.transform = "scale(1.02, 1.02)"
        }
        return style
    }

    return (

        // frames tab of left panel
        <div id="frames-palette" style={{textAlign: 'center'}}>
            <table style={{margin: 'auto', width: '100%'}}>
                {frames.filter((id) => framesMap[id] && framesMap[id].visible).map((id, i) => {
                        let frame = framesMap[id]
                        return <tbody
                                key={id}
                                onMouseDown={() => selectFrame(id)}
                                draggable={true}
                                onDragStart={(event) => drag(event, id)}
                                onDragOver={(event) => dragOver(event, id)}
                                onDrop={drop}
                                onDragEnd={drop}>
                            <tr>
                                <td>
                                        <svg viewBox="0 0 800 600" style={getStyle(id)} onClick={(e) => {setEditState(false)}}>
                                            {shapes.map((shapeId, idx) => {
                                                return shapeRenderer.forShape(shapesMap[shapeId])
                                                    .forFrame(id)
                                                    .withKey(idx)
                                                    .render()
                                            })}
                                        </svg>
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{paddingBottom: '10px'}} 
                                        onClick={(e) => {setEditState(true)}} 
                                        onDoubleClick={(e) => {setEditState(false)}}>

                                        {editState ? <input className="frame-name" type="text" 
                                                            defaultValue={frame.name}
                                                            onKeyDown={(e) => {
                                                                if (e.key === "Enter"){

                                                                    changeFrameName(frame.id, e.target.value)
                                                                    console.log(e.target.value)
                                                                    console.log(framesMap)
                                                                    setEditState(false)
                                                                }
                                                            }}
                                            ></input> : <div>{frame.name}</div>}

                                    </td>
                                </tr>
                            </tbody>})}
                    <tbody>
                        <tr>
                            <td>
                                <button onClick={addFrame} style={{width: '100%', padding: '5px'}}>New Frame</button>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <button onClick={deleteSelectedFrame} style={{width: '100%', padding: '5px'}}>Delete Frame</button>                            
                            </td>
                        </tr>
                        <tr id="ghostlayer" style={{opacity: "0", width:"100%", height:"1px", visibility: "hidden"}}></tr>
                    </tbody>
            </table>
        </div>
    )

}

export default FramesPalette;